import { Box, Typography, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { Outlet } from "react-router-dom";

import AccessNavRail from "../../components/Access/AccessNavRail";
import {
  heroText,
  motionVariants,
  pageBackground,
} from "../../helpers/designSystem";

/**
 * Route element for /access. Renders:
 *   - Page hero ("Access")
 *   - <AccessNavRail /> horizontal sub-nav
 *   - <Outlet /> for the active child (Members / Invitations / …)
 *
 * Wrapped upstream in <ProtectedRoutes requiredRole={[SYSTEM, 'ACCOUNT_ADMIN']} />
 * in src/App.js so unauthorized users never even see the hero.
 */
export default function AccessLayout() {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        ...pageBackground(isDarkMode),
        mx: -3,
        mt: -3,
        px: 3,
        pt: 3,
        pb: 4,
        minHeight: "calc(100vh - 96px)",
      }}
    >
      <Box
        component={motion.div}
        initial="initial"
        animate="animate"
        variants={motionVariants?.heroEnter}
        sx={{ mb: 2 }}
      >
        <Typography
          variant="h4"
          sx={{ ...heroText(isDarkMode), fontWeight: 700, letterSpacing: "-0.01em" }}
        >
          Access
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "text.secondary", mt: 0.5, maxWidth: 640 }}
        >
          Who can do what in this account. Roles shown are labels until
          enforcement lands in Phase&nbsp;2.
        </Typography>
      </Box>

      <AccessNavRail />

      <Outlet />
    </Box>
  );
}
